import React from 'react'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'

import {
  useCurrentCompanyServicesQuery,
  useInvalidateCurrentCompanyServicesQuery,
} from '../../hooks/useCompanyServicesQuery'
import useNotyf from '../../hooks/useNotyf'
import { GETTING_STARTED_STEP_TITLES } from '../flows/CompleteRegistrationFlow/constants'
import CompanyServices from '../flows/CompleteRegistrationFlow/steps/1_CompanyServices/CompanyServices'
import LoadingWidget from '../widgets/LoadingWidget'

interface Props {
  onHide: () => void
}

/**
 * Displays a modal allowing the user to select services. Deliberately
 * not dismissable until they have, since we really want the user to select some
 */
const SelectServicesModal: React.FC<Props> = ({ onHide }) => {
  const notyf = useNotyf()
  const companyServicesQuery = useCurrentCompanyServicesQuery()
  const invalidateCurrentCompanyServicesQuery =
    useInvalidateCurrentCompanyServicesQuery()

  const companyServices = companyServicesQuery.data

  // Can't be dismissed while there's still only one service (or no services) selected
  const locked =
    companyServicesQuery.isPending ||
    companyServices === undefined ||
    companyServices.length <= 1

  function hide() {
    notyf.success("Thank you for selecting your company's services")
    onHide()
  }

  return (
    <Modal show size="lg" centered fullscreen="md-down">
      <Modal.Header>
        <h2 className="mb-0">
          <strong>{GETTING_STARTED_STEP_TITLES.companyServices}</strong>
        </h2>
      </Modal.Header>

      <Modal.Body>
        {companyServices === undefined ? (
          <LoadingWidget />
        ) : (
          <CompanyServices
            onUpdate={() => invalidateCurrentCompanyServicesQuery()}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <OverlayTrigger
          overlay={
            locked ? (
              <Tooltip>Please select at least 2 services to continue</Tooltip>
            ) : (
              <></>
            )
          }
        >
          {/* `span` because OverlayTrigger doesn't work on `button` elements */}
          <span>
            <Button
              disabled={locked}
              size="lg"
              variant="success"
              onClick={hide}
            >
              Done
            </Button>
          </span>
        </OverlayTrigger>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectServicesModal
